module.exports = __webpack_public_path__ + "static/media/Profile-photo-Tomas.ce0239a3.jpg";